import { render, staticRenderFns } from "./publicNavigation.vue?vue&type=template&id=221aabb0&scoped=true"
import script from "./publicNavigation.vue?vue&type=script&lang=js"
export * from "./publicNavigation.vue?vue&type=script&lang=js"
import style0 from "./publicNavigation.vue?vue&type=style&index=0&id=221aabb0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221aabb0",
  null
  
)

export default component.exports